import { PhoneShell } from './PhoneShell'
import { QrScanner } from './screens/QrScanner'
import { ShareInvite } from './screens/ShareInvite'
import { ShareSheet } from './ShareSheet'
import { Toast } from './Toast'
import type { Vals } from '../demo/vals'

import { AppChrome } from './screens/manager/AppChrome'
import { AlertFeed } from './screens/manager/AlertFeed'
import { Connect } from './screens/manager/Connect'
import { GroupDashboard } from './screens/manager/GroupDashboard'
import { Invite } from './screens/manager/Invite'
import { LockScreen } from './screens/manager/LockScreen'
import { MemberDetail } from './screens/manager/MemberDetail'
import { Monitor } from './screens/manager/Monitor'
import { Profile } from './screens/manager/Profile'
import { PurchaseSuccess } from './screens/manager/PurchaseSuccess'
import { ThreatProtection } from './screens/manager/ThreatProtection'
import { UpgradeCheckout } from './screens/manager/UpgradeCheckout'
import { UpgradeTerm } from './screens/manager/UpgradeTerm'

/**
 * Michael's handset — the managing side: plan, seats, invites, alert feed.
 *
 * Exactly one screen is visible at a time; `AppChrome` and `Toast` overlay
 * whichever it is.
 */
export function ManagerPhone({ v, scale }: { v: Vals; scale: number }) {
  return (
    <PhoneShell label="Manager phone" scale={scale} finish="titanium">
      {v.mAppChrome ? <AppChrome v={v} /> : null}
      {v.toastM ? <Toast text={v.toastM} /> : null}

      {v.mLock ? <LockScreen v={v} /> : null}
      {v.mConnect ? <Connect v={v} /> : null}
      {v.mProtect ? <ThreatProtection v={v} /> : null}
      {v.mMonitor ? <Monitor v={v} /> : null}
      {v.mProfile ? <Profile v={v} /> : null}

      {v.mTerm ? <UpgradeTerm v={v} /> : null}
      {v.mCheckout ? <UpgradeCheckout v={v} /> : null}
      {v.mSuccess ? <PurchaseSuccess v={v} /> : null}

      {v.mSub ? <GroupDashboard v={v} /> : null}
      {v.mMember ? <MemberDetail v={v} /> : null}
      {v.mInvite ? <Invite v={v} /> : null}

      {v.mAlerts ? <AlertFeed v={v} /> : null}
      {v.mShareInvite ? (
        <ShareInvite v={v} onBack={v.managerClosePairing} onSend={v.sendPairRequest} />
      ) : null}
      {v.mScanner ? (
        <QrScanner onBack={v.managerClosePairing} onScan={() => v.completePairing('m')} />
      ) : null}

      {v.shareSheetOpen ? <ShareSheet v={v} /> : null}
    </PhoneShell>
  )
}
